export default __webpack_public_path__ + "static/media/cruises.33245f37.png";